var imgGalleries = document.querySelectorAll('.js-img-gallery');

if (imgGalleries.length > 0) {
    document.querySelectorAll('.lightbox').forEach(link => {
        var img = new Image();
        img.src = link.getAttribute('href');

        img.onload = () => {
            var naturalWidth = img.naturalWidth;
            var naturalHeight = img.naturalHeight;

            if (img.naturalWidth > 1180) {
                naturalHeight = (img.naturalHeight * 1180) / img.naturalWidth;
                naturalWidth = 1180;
            }

            link.dataset.pswpHeight = naturalHeight;
            link.dataset.pswpWidth = naturalWidth;
        };
    });

    var lightbox = new PhotoSwipeLightbox({
        gallery: '.img-gallery-list',
        children: '.img-gallery-item',
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 1.5,
        closeTitle: 'Fermer',
        zoomTitle: 'Zoom',
        arrowPrevTitle: 'Précédent',
        arrowNextTitle: 'Suivant',
        indexIndicatorSep: ' sur ',
        pswpModule: PhotoSwipe
    });

    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'custom-caption',
            order: 9,
            isButton: false,
            appendTo: 'root',
            onInit: (el, pswp) => {
                lightbox.pswp.on('change', () => {
                    var currSlideElement = lightbox.pswp.currSlide.data.element;
                    let captionHTML = '';
                    if (currSlideElement) {
                        var hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
                        if (hiddenCaption) {
                            captionHTML = hiddenCaption.innerHTML;
                        } else if (currSlideElement.querySelector('img').getAttribute('alt').length > 0){
                            captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                        }
                    }
                    if(captionHTML !== '') {
                        el.innerHTML = '<p>' + (captionHTML || '') + '</p>';
                    } else{
                        el.innerHTML = '';
                    }
                });
            }
        });
    });

    lightbox.init();

    imgGalleries.forEach(imgGallery => {
        if (imgGallery.classList.contains('splide')) {
            startSlider(imgGallery)
        }
    })
}

var galleries = document.querySelectorAll('.js-gallery');

galleries.forEach(gallery => {
    if (gallery.classList.contains('splide')) {
        startSlider(gallery)
    }
})

function startSlider(gallery){
    var isNotice = false

    var gap = 20;

    var splideInstance = null;

    function initSlider() {

        if (splideInstance) {
            splideInstance.destroy(true);
            splideInstance = null;
        }

        var splideParams = {
            autoWidth: true,
            perMove: 1,
            gap: `${gap / 16}rem`,
            snap: false,
            arrows: false,
            pagination: false,
            drag: 'free',
        }

        if (gallery.classList.contains('js-ressources')) {
            splideParams.arrows = true;
            splideParams.autoHeight = true;
            splideParams.snap = true;
            isNotice = true
        } else {
            splideParams.height = "17.5rem"
        }

        splideInstance = new Splide(gallery, splideParams);

        splideInstance.on('overflow', function (isOverflow) {

            splideInstance.go(0);


            splideInstance.options = {
                arrows: isOverflow,
                pagination: (isOverflow) ? isNotice ? false : 'free' : isOverflow,
                drag: (isOverflow) ? 'free' : false,
            };
        });


        splideInstance.mount();

    }

    // Init au chargement
    initSlider();

    // Reinit au resize (avec debounce)
    var resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initSlider();
        }, 200);
    });
}